'use client';

import { ApolloProvider } from '@apollo/client';
import { CartProvider } from './CartProvider';
import client from '@/lib/apollo/apollo-client';
export default function Providers({
  children
}: {
  children: React.ReactNode;
}) {
  return <>
      <ApolloProvider client={client} data-sentry-element="ApolloProvider" data-sentry-source-file="index.tsx">
        <CartProvider data-sentry-element="CartProvider" data-sentry-source-file="index.tsx">{children}</CartProvider>
      </ApolloProvider>
    </>;
}